import Vue from 'vue'
import { Toast } from 'vant';
import { Dialog } from 'vant';


// Toast.setDefaultOptions({
//   className: 'set-toast'
// })

Dialog.setDefaultOptions({
  className: 'set-dialog'
})



Vue.use(Toast);
Vue.use(Dialog);
